export default __webpack_public_path__ + "static/media/qantas-qff.3285f704.svg";